import { render, staticRenderFns } from "./TitleRich.vue?vue&type=template&id=14dcab23&lang=pug&"
import script from "./TitleRich.vue?vue&type=script&lang=js&"
export * from "./TitleRich.vue?vue&type=script&lang=js&"
import style0 from "./TitleRich.vue?vue&type=style&index=0&id=14dcab23&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports